<template>
  <v-container fluid class="pa-0 ma-0">
    <v-list-item v-if="showAdd" @click="onAddClicked">
      <v-list-item-content>
        <v-list-item-title class="text-center">
          <v-icon large color="primary" class="mr-2">mdi-plus-circle</v-icon>
          <span>Schacht hinzufügen</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <template v-for="item in shafts">
      <ShaftListItem
        :key="item.id"
        :item="item"
        @itemClick="onItemClicked"
        @duplicateClick="onDuplicateClicked"
        @deleteClick="onDeleteClicked"
      />
      <v-divider :key="item.id + '_Divider'" />
    </template>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import ShaftListItem from '@/components/ShaftListItem.vue';

export default {
  name: 'ShaftList',
  components: { ShaftListItem },
  props: ['shafts', 'site', 'showAdd'],
  methods: {
    ...mapActions(['deleteShaft', 'setCurrentShaft']),
    onAddClicked() {
      if (this.site) this.$router.push('/schacht/add?site=' + this.site.id);
      else this.$router.push('/schacht/add');
    },
    onItemClicked(item) {
      this.setCurrentShaft(item);
      this.$router.push('/schacht/' + item.id);
    },
    onDuplicateClicked(item) {
      this.$router.push(
        '/schacht/add?shaft=' + item.id + '&site=' + item.site_id.id,
      );
    },
    async onDeleteClicked(item) {
      await this.deleteShaft(item);
    },
  },
};
</script>

<style scoped></style>
